import React from 'react'
import Activities, { ActivityPayload } from '@/components/Activities'
import { getContractUpdates } from '../../services'
import Paper from '@/components/Paper'
import { Typogaphy } from 'vnetwork-ui'
import { useTranslation } from 'react-i18next'

interface IListProps {
    contractID: number
}
const ListComponent: React.FC<IListProps> = ({ contractID = 1 }) => {
    const { t } = useTranslation()
    const wrappedApiCall = ({ page, page_size }: ActivityPayload) =>
        getContractUpdates({
            contractID,
            payload: {
                page,
                page_size,
            },
        })
    return (
        <Paper className="mt-2">
            <Typogaphy className="mb-2 font-medium text-primary capitalize">
                {t('activity')}
            </Typogaphy>
            <Activities
                apiCall={wrappedApiCall}
                queryKey={`contracts.customers.${contractID}.actions`}
            />
        </Paper>
    )
}

const List = (props: IListProps) => {
    return <ListComponent {...props} />
}
export default List
